export function validateFullName(value: string) {
  if (!value) return false
  const words = value
    .split(' ')
    .filter((word) => word !== '' && word.length >= 2)
  return words.length >= 2
}
